import { useCallback } from "react";

import { ComponentStateHooks } from "@tsmono/react/state";
import { getOwn } from "@tsmono/util";

import { useStore } from "./store";

export const inspectStateHooks: ComponentStateHooks = {
  useValue: (id: string, prop: string, defaultValue?: unknown) =>
    useStore(
      useCallback(
        (state) => state.appActions.getPropertyValue(id, prop, defaultValue),
        [id, prop, defaultValue]
      )
    ),
  useSetValue: () => useStore((state) => state.appActions.setPropertyValue),
  useRemoveValue: () =>
    useStore((state) => state.appActions.removePropertyValue),
  useEntries: (id: string) =>
    useStore(useCallback((state) => getOwn(state.app.propertyBags, id), [id])),
  useRemoveAll: () => useStore((state) => state.appActions.removeAllProperties),
  useRemoveByPrefix: () => useStore((state) => state.appActions.removeByPrefix),
};
